import {ClaimNoteTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class ClaimNoteTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ClaimNoteTypeCd ) {
      this._values.push(ClaimNoteTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ClaimNoteTypeCd {

    for ( const obj in ClaimNoteTypeCd ) {
      if (ClaimNoteTypeCd[obj] === value){
        return ClaimNoteTypeCd[obj] as ClaimNoteTypeCd;
      }
    }
  }
}

const ClaimNoteTypeCdHelper = new ClaimNoteTypeCdHelperEnumHelperClass();
export default ClaimNoteTypeCdHelper;
